const defaultTranslation = {
  tab: {
    noQuery: 'Type in search.',
    notFound: 'Sorry, no results found.',
    loading: 'Loading...',
    allResults: 'All Results: ',
    learnMore: 'Learn more',
    search: 'Search'
  },
  providers: {
    articles: 'Articles',
    products: 'Products'
  }
};


export type Translations = typeof defaultTranslation;

export type WithTranslations = { translations: Translations }

export const defaultIfNone = (translation: Translations) => {
  if (!translation) {
    return defaultTranslation
  }

  return translation;
}
export interface HsContext {
  language: string;
  store: string;
  apiUrl: string;
  storefrontUrl: string;
  translations: Translations
};